import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { SolicitacaoTransferenciaPendenteRptComponent } from './solicitacao-transferencia-pendente-rpt.component';

const routes: Routes = [
  { path: '', component: SolicitacaoTransferenciaPendenteRptComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SolicitacaoTransferenciaPendenteRptRoutingModule { }
